import { useAuthContext } from "providers/Auth";

import api from "../../api/landlord/renters";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import { signUp } from "./validations";
import { getErrorMessage } from "utils/error";
import { useForm } from "shared/hooks/use-form";
import { toast } from "react-toastify";

export const useSignUpController = () => {
  const { refreshAuth } = useAuthContext();
  const navigate = useNavigate();

  const { values, ...rest } = useForm(
    {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      phone: "",
      company_name: "",
      website: "",
      units: "",
      property_management_system: ""
    },
    signUp
  );

  const handleSubmit = async () => {
    return api
      .signUp({
        contact_first_name: values.first_name as string,
        contact_last_name: values.last_name as string,
        contact_phone_number: (values.phone as string).replace(/\D/g, ""),
        email: values.email as string,
        name: values.company_name as string,
        url: values.website as string,
        units: values.units as number,
        password: values.password as string,
        property_management_system: values.property_management_system as string
      })
      .then(() => refreshAuth())
      .then(() => navigate("/onboarding"))
      .catch((e: AxiosError) => {
        toast.error(getErrorMessage(e));
      });
  };

  return { values, ...rest, handleSubmit };
};
